var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGroup4(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 61,
    height: 60,
    viewBox: "0 0 61 60",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M55.2753 42.5464C54.4599 41.9886 53.3683 42.2561 52.2309 42.9241C49.7529 42.0574 43.9729 48.0339 43.9729 48.0339C41.9512 47.5351 37.6427 48.1693 37.6427 48.1693C36.6209 47.4739 33.666 47.3844 30.7711 47.4892C29.9808 47.3822 29.4884 47.3233 29.4884 47.3233L29.2636 47.5634C28.7876 47.5896 28.327 47.6224 27.8816 47.654C27.207 47.5612 26.7889 47.511 26.7889 47.511L26.5586 47.7588C25.0598 47.8898 24.0304 48.0121 24.0304 48.0121L16.0388 56.5975C16.0388 56.5975 17.9513 56.4523 20.4675 56.2973C24.3088 56.7602 33.6136 57.8911 35.7248 58.2174C36.8742 58.3921 37.8621 58.2524 38.635 58.0471C41.1981 58.3583 42.9937 57.1684 42.9937 57.1684C42.9937 57.1684 45.9847 55.4906 49.1165 53.8598C52.2483 52.2245 54.6542 48.7795 54.6542 48.7795C54.6542 48.7795 60.0063 43.8945 58.0404 42.4034C57.3013 41.8402 56.3189 42.005 55.2753 42.5464Z",
    fill: "#E6AB6E"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M8.33672 16.6613C10.8147 17.5281 16.5914 11.5516 16.5914 11.5516C18.6163 12.0504 22.9216 11.4151 22.9216 11.4151C23.9444 12.1137 26.9005 12.2022 29.7943 12.0952C30.5836 12.2043 31.0791 12.2622 31.0791 12.2622L31.3018 12.0242C31.7767 11.9969 32.2417 11.9642 32.6838 11.9315C33.3584 12.0242 33.7776 12.0755 33.7776 12.0755L34.009 11.8267C35.5045 11.6957 36.5339 11.5745 36.5339 11.5745L44.5277 2.98904C44.5277 2.98904 42.6185 3.13312 40.1034 3.28922C36.2664 2.8242 26.9518 1.6944 24.8417 1.37019C23.6923 1.19335 22.7022 1.3309 21.9293 1.54049C19.3684 1.22829 17.5739 2.41815 17.5739 2.41815C17.5739 2.41815 14.5818 4.09482 11.45 5.72677C8.31924 7.36199 5.91446 10.8082 5.91446 10.8082C5.91446 10.8082 0.562344 15.6909 2.52723 17.1832C3.26951 17.7442 4.25193 17.5783 5.29551 17.0379C6.10766 17.5968 7.19709 17.3272 8.33672 16.6613Z",
    fill: "#E6AB6E"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M17.7632 7.18743C10.9669 7.06953 5.42705 12.5133 5.39539 19.2998C5.36483 26.1136 10.8556 31.7135 17.6541 31.8129C24.4547 31.9307 29.9957 26.5109 30.0241 19.6993C30.0546 12.9063 24.5639 7.29768 17.7632 7.18743Z",
    fill: "url(#paint0_linear_2040_34400)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M30.0248 19.6993C29.9964 26.5098 24.4555 31.9307 17.6548 31.8128C10.8563 31.7135 5.36556 26.1136 5.39612 19.2998C5.42778 12.5133 10.9687 7.07059 17.764 7.18739C24.5646 7.29764 30.0554 12.9063 30.0248 19.6993Z",
    fill: "#FFB82B"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M17.6542 31.2073C10.9648 31.1156 5.57014 25.6827 5.42496 19.0098C5.42387 19.1113 5.39661 19.2019 5.39661 19.3023C5.36605 26.1161 10.8568 31.716 17.6553 31.8154C24.4559 31.9333 29.9969 26.5134 30.0253 19.7018C30.0253 19.596 29.998 19.4955 29.9948 19.3864C29.8081 26.0593 24.3555 31.323 17.6542 31.2073Z",
    fill: "#F5D5A4"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M17.7665 7.89696C24.4362 8.00612 29.8069 13.4084 29.9892 20.0214C29.9924 19.9133 30.023 19.8118 30.023 19.6994C30.0536 12.9063 24.5628 7.29877 17.7621 7.18743C10.9658 7.06953 5.42594 12.5133 5.39429 19.2998C5.39429 19.433 5.42594 19.5596 5.4314 19.695C5.63662 13.0624 11.0793 7.78562 17.7665 7.89696Z",
    fill: "#FFB82B"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M27.4629 19.6575C27.4422 25.0609 23.0561 29.34 17.6658 29.2549C12.2787 29.1687 7.92761 24.7368 7.95053 19.3508C7.97345 13.9528 12.3638 9.67375 17.752 9.76108C23.1412 9.84404 27.4902 14.2737 27.4629 19.6575Z",
    fill: "url(#paint1_linear_2040_34400)"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M17.6703 28.7607C12.3651 28.6723 8.08385 24.3714 7.98233 19.0957C7.97687 19.1808 7.95175 19.2649 7.95175 19.3522C7.92883 24.7393 12.28 29.1701 17.667 29.2563C23.0574 29.3415 27.4434 25.0624 27.4641 19.659C27.4641 19.5771 27.4434 19.5007 27.4412 19.4254C27.2775 24.7 22.9722 28.8448 17.6703 28.7607Z",
    fill: "#F5D5A4"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M17.6761 26.8551C15.065 26.8093 12.6853 25.316 11.466 22.9505C10.9071 21.8698 10.6156 20.6384 10.6222 19.3853C10.6375 15.3289 13.7147 12.1523 17.6204 12.1523C21.7194 12.2244 24.8206 15.5035 24.8021 19.6156C24.7846 23.6774 21.7041 26.8551 17.7896 26.8551H17.6761Z",
    fill: "#F5D5A4"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M24.5034 19.612C24.4892 23.366 21.4327 26.3396 17.6809 26.285C13.9323 26.2206 10.901 23.1499 10.9195 19.3893C10.9348 15.6484 13.9946 12.6541 17.7377 12.7218C21.4906 12.7862 24.5187 15.8646 24.5034 19.612Z",
    fill: "#FFD336"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M24.4652 19.9572C24.4652 19.9463 24.4641 19.9332 24.4641 19.9233C24.2545 23.1381 21.305 25.6488 17.6798 25.5964C14.0677 25.5429 11.152 22.9689 10.9577 19.752C10.9577 19.7552 10.9556 19.7661 10.9556 19.7661C11.139 23.3499 14.0601 26.2284 17.6798 26.2863C21.3149 26.3409 24.2709 23.542 24.4652 19.9572Z",
    fill: "#F5D5A4"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M17.7396 13.2392C21.3976 13.3014 24.3427 16.2389 24.4781 19.8565C24.4803 19.7746 24.5021 19.6971 24.5021 19.6131C24.5174 15.8656 21.4893 12.7873 17.7364 12.7218C13.9933 12.6552 10.9335 15.6494 10.9182 19.3893C10.9182 19.4831 10.9433 19.5716 10.9466 19.6655C11.0896 16.0413 14.0762 13.1737 17.7396 13.2392Z",
    fill: "#FFB82B"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M17.0801 23.9584C16.6882 23.9245 16.3563 23.8743 16.0736 23.799C15.7942 23.728 15.5737 23.6243 15.4066 23.5184L15.8247 22.1834C15.9448 22.2893 16.1118 22.3712 16.3334 22.4454C16.5539 22.5185 16.8006 22.5742 17.0855 22.6113L17.0986 19.9238C16.8879 19.7961 16.6827 19.6476 16.4764 19.5046C16.2734 19.3529 16.0922 19.1673 15.9295 18.973C15.7691 18.7678 15.637 18.5353 15.5442 18.2602C15.435 18.0048 15.3914 17.686 15.3914 17.3116C15.3935 16.6654 15.5496 16.1785 15.8618 15.7997C16.1762 15.4253 16.5976 15.1884 17.1226 15.0793L17.1259 13.9473L18.2972 13.9713L18.2939 15.0531C18.5745 15.0782 18.8332 15.1262 19.0493 15.1982C19.272 15.2583 19.4827 15.3358 19.6781 15.4297L19.2622 16.709C19.1465 16.6402 19.0078 16.5726 18.8354 16.5147C18.6716 16.4645 18.4882 16.4208 18.2874 16.3903L18.2699 18.8235C18.4872 18.9479 18.6945 19.0975 18.9063 19.2623C19.1104 19.4118 19.3026 19.581 19.4685 19.8081C19.6312 20.0024 19.7709 20.2502 19.8746 20.5089C19.9794 20.7742 20.034 21.0787 20.034 21.44C20.0285 22.1419 19.8658 22.6954 19.546 23.0927C19.2294 23.4933 18.7928 23.775 18.247 23.8907L18.2437 25.0423L17.0757 25.0281L17.0801 23.9584ZM17.6346 16.3619C17.3344 16.3925 17.1314 16.4994 17.0233 16.6763C16.9098 16.8378 16.8563 17.0376 16.8563 17.2243C16.8563 17.4863 16.9251 17.7166 17.0724 17.8912C17.222 18.0593 17.4065 18.2285 17.6226 18.3934L17.6346 16.3619ZM17.7525 22.6157C18.0145 22.5567 18.2132 22.4596 18.3431 22.262C18.4741 22.0764 18.5395 21.8428 18.5439 21.5623C18.5461 21.2839 18.474 21.0514 18.3278 20.868C18.1793 20.6824 17.9948 20.4958 17.7634 20.3604L17.7525 22.6157Z",
    fill: "url(#paint2_linear_2040_34400)"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M19.8768 20.5089C19.7731 20.2513 19.6333 20.0024 19.4707 19.8081C19.3058 19.581 19.1126 19.4118 18.9085 19.2623C18.6967 19.0975 18.4893 18.9479 18.2721 18.8235L18.2896 16.3903C18.4904 16.4208 18.6738 16.4645 18.8376 16.5147C19.0089 16.5726 19.1476 16.6392 19.2644 16.709L19.6803 15.4297C19.4849 15.3358 19.2742 15.2583 19.0515 15.1982C18.8354 15.1273 18.5756 15.0793 18.2961 15.0531L18.2994 13.9713L17.1281 13.9473L17.1248 15.0793C16.5998 15.1884 16.1784 15.4253 15.864 15.7997C15.5518 16.1785 15.3957 16.6654 15.3936 17.3116C15.3936 17.686 15.4372 18.0048 15.5464 18.2602C15.6391 18.5353 15.7701 18.7689 15.9317 18.973C16.0943 19.1684 16.2756 19.354 16.4786 19.5046C16.6849 19.6476 16.8901 19.7961 17.1008 19.9238L17.0877 22.6113C16.8017 22.5742 16.5561 22.5185 16.3356 22.4454C16.114 22.3712 15.947 22.2893 15.8269 22.1834L15.4088 23.5184C15.5759 23.6243 15.7964 23.728 16.0758 23.799C16.3585 23.8743 16.6904 23.9245 17.0823 23.9584L17.079 25.0281L18.247 25.0423L18.2503 23.8907C18.7961 23.775 19.2327 23.4933 19.5493 23.0927C19.8691 22.6965 20.0318 22.1419 20.0372 21.44C20.0361 21.0798 19.9815 20.7742 19.8768 20.5089ZM19.3845 22.6124C19.1017 22.9748 18.6967 23.2215 18.2175 23.3198L17.9566 23.382L17.9501 24.467L17.3803 24.4605L17.3824 23.4115L17.0921 23.3863C16.7122 23.3612 16.3913 23.311 16.1184 23.239C16.03 23.216 15.9459 23.1899 15.8695 23.156L15.9579 22.8733C16.0529 22.9224 16.1566 22.9694 16.2832 23.0054C16.5135 23.0883 16.769 23.1429 17.0681 23.1811L17.3835 23.2204L17.401 19.5112C17.401 19.5112 16.8017 19.1247 16.6096 18.9916C16.4022 18.8366 16.2374 18.675 16.0911 18.4938C15.9601 18.3279 15.8607 18.1423 15.7909 17.9469C15.7199 17.7668 15.6916 17.5725 15.6916 17.3105C15.6916 16.8684 15.792 16.5562 16.0245 16.2789C16.2963 15.9558 16.6762 15.7419 17.1576 15.6436L17.4174 15.5901L17.4239 14.5203L17.997 14.5345L17.9948 15.5978L18.2797 15.6218C18.5461 15.6436 18.7961 15.6905 19.0002 15.7582C19.069 15.7768 19.1366 15.7997 19.2032 15.8183L19.1312 16.0486C19.0548 16.0202 18.974 15.9853 18.8867 15.958C18.7207 15.9034 18.5276 15.8619 18.3169 15.8216L17.9948 15.7615L17.973 19.2481L18.1892 19.3649C18.3944 19.4828 18.5963 19.6258 18.7993 19.7862C19.0155 19.9522 19.1738 20.0995 19.2982 20.2676C19.439 20.4401 19.5504 20.6366 19.6377 20.8506C19.7065 21.0241 19.7381 21.2097 19.7381 21.4324C19.7316 21.9443 19.6192 22.321 19.3845 22.6124Z",
    fill: "#F5D5A4"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M48.2757 11.2517C48.2757 11.2517 45.4986 13.1871 43.8667 13.9097C40.7131 15.2983 37.9338 18.2096 32.9703 17.011C28.009 15.8135 24.2943 15.0035 21.1177 14.9282C19.6528 14.8922 14.9163 15.2906 15.2449 12.1752C15.5451 9.30862 20.4573 10.1645 21.5707 10.0848C22.6809 10.0051 28.772 9.8206 28.772 9.8206C28.772 9.8206 20.8044 8.44299 18.5383 6.98789C18.5383 6.98789 12.6895 9.09468 9.67228 9.4822C9.67228 9.4822 3.30498 18.4148 0.46136 16.3833C-1.545 14.9457 3.64229 9.92976 3.64229 9.92976C3.64229 9.92976 5.951 6.4159 9.03587 4.69336C12.1196 2.9719 15.0615 1.21221 15.0615 1.21221C15.0615 1.21221 16.9183 -0.110809 19.6037 0.224313C22.2923 0.559434 37.3291 1.86171 37.3291 1.86171C37.3291 1.86171 41.2447 1.8399 42.6801 1.42728C44.0337 1.03758 45.8665 0.171944 45.8665 0.171944L48.2757 11.2517Z",
    fill: "url(#paint3_linear_2040_34400)"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M44.6727 0.0109267L44.6246 16.7135L41.1206 16.7015L41.1675 0L44.6727 0.0109267Z",
    fill: "url(#paint4_linear_2040_34400)"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M51.7128 0.0379361L51.6669 16.7394L44.625 16.7143L44.673 0.0117188L51.7128 0.0379361Z",
    fill: "url(#paint5_linear_2040_34400)"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M41.9218 27.5116C35.1255 27.3948 29.5856 32.8386 29.555 39.624C29.5256 46.4389 35.0152 52.0388 41.8126 52.1392C48.6133 52.2539 54.1554 46.834 54.1848 40.0246C54.2121 33.2283 48.7247 27.6219 41.9218 27.5116Z",
    fill: "url(#paint6_linear_2040_34400)"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M54.1844 40.0246C54.1549 46.8329 48.6139 52.2539 41.8122 52.1392C35.0148 52.0388 29.5251 46.4389 29.5546 39.624C29.5851 32.8386 35.1261 27.3948 41.9213 27.5116C48.7242 27.6219 54.2116 33.2283 54.1844 40.0246Z",
    fill: "#FFB82B"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M41.8125 51.5296C35.1221 51.4368 29.7296 46.0039 29.5844 39.332C29.5822 39.4336 29.556 39.5242 29.556 39.6246C29.5266 46.4395 35.0162 52.0394 41.8136 52.1398C48.6143 52.2544 54.1563 46.8346 54.1858 40.0252C54.1858 39.9182 54.1563 39.8167 54.1531 39.7075C53.9675 46.3816 48.5139 51.6464 41.8125 51.5296Z",
    fill: "#F5D5A4"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M41.9272 28.2211C48.5958 28.3292 53.9675 33.7305 54.1487 40.3456C54.1509 40.2364 54.1837 40.1349 54.1837 40.0246C54.2109 33.2283 48.7235 27.6219 41.9217 27.5116C35.1254 27.3948 29.5855 32.8386 29.5549 39.624C29.5549 39.7583 29.5855 39.8838 29.5909 40.0192C29.7962 33.3855 35.2389 28.1098 41.9272 28.2211Z",
    fill: "#FFB82B"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M51.6239 39.9788C51.6009 45.3811 47.2171 49.6624 41.8245 49.5761C36.4375 49.4888 32.0853 45.058 32.1137 39.6731C32.1344 34.2741 36.5259 29.9939 41.9108 30.0834C47.3022 30.1642 51.6468 34.5939 51.6239 39.9788Z",
    fill: "url(#paint7_linear_2040_34400)"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M41.8311 49.0811C36.5259 48.9948 32.2446 44.6906 32.142 39.416C32.1366 39.5001 32.1137 39.5863 32.1137 39.6736C32.0864 45.0596 36.4375 49.4893 41.8245 49.5766C47.217 49.6629 51.6009 45.3816 51.6239 39.9793C51.6239 39.8985 51.6009 39.821 51.5987 39.7467C51.4372 45.0203 47.1319 49.1662 41.8311 49.0811Z",
    fill: "#F5D5A4"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M41.8366 47.1774C39.2233 47.1315 36.8447 45.6371 35.6243 43.2727C35.0654 42.191 34.7761 40.9607 34.7816 39.7065C34.7979 35.6501 37.873 32.4746 41.7798 32.4746C45.8777 32.5488 48.9789 35.8258 48.9626 39.9379C48.9429 43.9997 45.8635 47.1774 41.949 47.1774H41.8366Z",
    fill: "#F5D5A4"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M48.6628 39.9342C48.6465 43.6882 45.5911 46.6617 41.8392 46.6083C38.0918 46.5439 35.0615 43.4743 35.0811 39.7126C35.0942 35.9728 38.1529 32.9785 41.8982 33.044C45.6489 33.1095 48.6803 36.1889 48.6628 39.9342Z",
    fill: "#FFD336"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M48.6247 40.2803C48.6247 40.2705 48.6247 40.2563 48.6247 40.2464C48.414 43.4623 45.4645 45.9719 41.8382 45.9206C38.2282 45.866 35.3126 43.292 35.1161 40.0762C35.1161 40.0805 35.115 40.0904 35.115 40.0904C35.2984 43.6741 38.2184 46.5537 41.8382 46.6116C45.4732 46.6629 48.4293 43.8651 48.6247 40.2803Z",
    fill: "#F5D5A4"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M41.8994 33.5625C45.5585 33.6258 48.5025 36.5622 48.639 40.1809C48.6433 40.0957 48.663 40.0204 48.663 39.9353C48.6805 36.19 45.6491 33.1106 41.8983 33.044C38.1531 32.9796 35.0944 35.9739 35.0813 39.7126C35.0813 39.8087 35.1042 39.8938 35.1064 39.9888C35.2516 36.3657 38.236 33.4981 41.8994 33.5625Z",
    fill: "#FFB82B"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M43.6839 36.3889V34.6445C40.7595 34.6445 38.8666 35.8835 38.442 38.3265H37.5491V39.1004H38.3623C38.3579 39.2129 38.3492 39.322 38.3492 39.4366C38.3492 39.6037 38.359 39.7663 38.371 39.9235H37.5491V41.1341H38.6047C39.2531 43.1219 41.1033 44.1851 43.6839 44.1851V42.4407C42.1589 42.4407 41.2518 42.0292 40.8108 41.1341H43.3116V39.9235H40.5106C40.4997 39.7652 40.4833 39.6113 40.4833 39.4366C40.4833 39.3198 40.4844 39.2107 40.4909 39.1004H43.3127V38.3265H40.5761C40.8479 36.9412 41.7517 36.3889 43.6839 36.3889Z",
    fill: "url(#paint8_linear_2040_34400)"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M43.6839 36.3889V34.6445C40.7595 34.6445 38.8666 35.8835 38.442 38.3265H37.5491V39.1004H38.3623C38.3579 39.2129 38.3492 39.322 38.3492 39.4366C38.3492 39.6037 38.359 39.7663 38.371 39.9235H37.5491V41.1341H38.6047C39.2531 43.1219 41.1033 44.1851 43.6839 44.1851V42.4407C42.1589 42.4407 41.2518 42.0292 40.8108 41.1341H43.3116V39.9235H40.5106C40.4997 39.7652 40.4833 39.6113 40.4833 39.4366C40.4833 39.3198 40.4844 39.2107 40.4909 39.1004H43.3127V38.3265H40.5761C40.8479 36.9412 41.7517 36.3889 43.6839 36.3889ZM40.1711 38.2468L40.075 38.7358H40.0947C40.0947 38.7358 40.0707 39.3122 40.0707 39.4366C40.0707 39.5949 40.0827 39.7368 40.0947 39.8809L40.1253 40.2553L40.5095 40.335H42.9001V40.7247H40.1526L40.4429 41.3153C40.9156 42.2759 41.8183 42.766 43.2724 42.8424V43.767C41.0553 43.659 39.5434 42.6918 38.9966 41.0075L38.9037 40.7247H37.9595V40.335H38.8153L38.7804 39.8929C38.7695 39.7445 38.7586 39.5949 38.7586 39.4366L38.7924 38.7806L38.5784 38.7358H38.7881L38.8448 38.3963C39.2924 35.8256 41.4134 35.1467 43.2724 35.0626V35.9861C41.4013 36.0724 40.4647 36.7611 40.1711 38.2468Z",
    fill: "#F5D5A4"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "M12.2915 48.3375C12.2915 48.3375 15.0674 46.401 16.6994 45.6795C19.8519 44.291 22.6312 41.3786 27.5925 42.5782C32.5549 43.7768 36.2718 44.5835 39.4484 44.6599C40.9133 44.697 45.6476 44.2997 45.3201 47.414C45.021 50.2828 40.1066 49.4248 38.9965 49.5034C37.8852 49.5831 31.793 49.7675 31.793 49.7675C31.793 49.7675 39.7595 51.1462 42.0289 52.6013C42.0289 52.6013 47.8777 50.4956 50.8949 50.1059C50.8949 50.1059 57.26 41.1744 60.1026 43.2059C62.1133 44.6414 56.9227 49.6584 56.9227 49.6584C56.9227 49.6584 54.6151 53.1722 51.5313 54.8959C48.4486 56.6162 45.5046 58.377 45.5046 58.377C45.5046 58.377 43.6499 59.7011 40.9646 59.3649C38.2738 59.0276 23.237 57.7253 23.237 57.7253C23.237 57.7253 19.3214 57.7493 17.8892 58.1598C16.5313 58.5506 14.6996 59.4162 14.6996 59.4162L12.2915 48.3375Z",
    fill: "url(#paint9_linear_2040_34400)"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    d: "M15.8923 59.5726L15.9393 42.8711L19.4444 42.8831L19.3964 59.5824L15.8923 59.5726Z",
    fill: "url(#paint10_linear_2040_34400)"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    d: "M8.8501 59.5481L8.8981 42.8477L15.9389 42.8739L15.892 59.5754L8.8501 59.5481Z",
    fill: "url(#paint11_linear_2040_34400)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_2040_34400",
    x1: 5.39561,
    y1: 19.4999,
    x2: 30.0241,
    y2: 19.4999,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DD3F18"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4157,
    stopColor: "#E74A1B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FD6120"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_2040_34400",
    x1: 17.7075,
    y1: 29.256,
    x2: 17.7075,
    y2: 9.75911,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF7B00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0242,
    stopColor: "#FF7D01"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6742,
    stopColor: "#FFAB0F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFBD14"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_2040_34400",
    x1: 17.7143,
    y1: 25.0416,
    x2: 17.7143,
    y2: 13.9477,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF7B00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0242,
    stopColor: "#FF7D01"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6742,
    stopColor: "#FFAB0F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFBD14"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_2040_34400",
    x1: 24.137,
    y1: 17.2932,
    x2: 24.137,
    y2: 0.168095,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0242,
    stopColor: "#F7BB7C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFD1A1"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_2040_34400",
    x1: 42.8964,
    y1: 16.7131,
    x2: 42.8964,
    y2: 0,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#CDEFFA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FAFAFA"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_2040_34400",
    x1: 48.1688,
    y1: 16.7394,
    x2: 48.1688,
    y2: 0.0115004,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#062A54"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2719,
    stopColor: "#072C58"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5179,
    stopColor: "#083263"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7539,
    stopColor: "#0B3C75"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9825,
    stopColor: "#104B8F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#104C91"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_2040_34400",
    x1: 29.5552,
    y1: 39.8253,
    x2: 54.1846,
    y2: 39.8253,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DD3F18"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4157,
    stopColor: "#E74A1B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FD6120"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear_2040_34400",
    x1: 41.8687,
    y1: 49.5774,
    x2: 41.8687,
    y2: 30.0816,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF7B00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0242,
    stopColor: "#FF7D01"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6742,
    stopColor: "#FFAB0F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFBD14"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint8_linear_2040_34400",
    x1: 39.1642,
    y1: 36.4381,
    x2: 45.2977,
    y2: 42.5715,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFBD14"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0524,
    stopColor: "#FFB612"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2728,
    stopColor: "#FF9C0A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5004,
    stopColor: "#FF8A04"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7377,
    stopColor: "#FF7F01"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF7B00"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint9_linear_2040_34400",
    x1: 36.4281,
    y1: 59.4214,
    x2: 36.4281,
    y2: 42.2956,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0242,
    stopColor: "#F7BB7C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFD1A1"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint10_linear_2040_34400",
    x1: 17.6684,
    y1: 59.5824,
    x2: 17.6684,
    y2: 42.8715,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#CDEFFA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FAFAFA"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint11_linear_2040_34400",
    x1: 12.3945,
    y1: 59.5756,
    x2: 12.3945,
    y2: 42.8477,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#062A54"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2719,
    stopColor: "#072C58"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5179,
    stopColor: "#083263"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7539,
    stopColor: "#0B3C75"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9825,
    stopColor: "#104B8F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#104C91"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGroup4);
export default __webpack_public_path__ + "static/media/Group (4).7e94d82659bf395f5dde1053bf9d4bb6.svg";
export { ForwardRef as ReactComponent };